export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  coverImage: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '电影资讯',
    slug: 'movie-news',
    description: '最新电影动态、定档信息、票房数据、影人影事',
    icon: 'ri-movie-2-line',
    coverImage: 'https://readdy.ai/api/search-image?query=cinema%20marquee%20with%20movie%20posters%2C%20warm%20golden%20lighting%2C%20red%20curtains%2C%20elegant%20theater%20entrance%2C%20vintage%20film%20aesthetic%2C%20clean%20composition&width=600&height=350&seq=category-cover-01&orientation=landscape',
    articleCount: 56,
  },
  {
    id: '2',
    name: '剧集推荐',
    slug: 'series-recommend',
    description: '热门电视剧推荐、剧评分析、追剧指南',
    icon: 'ri-tv-2-line',
    coverImage: 'https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20scene%2C%20warm%20ambient%20lighting%2C%20modern%20home%20theater%2C%20comfortable%20sofa%2C%20cinematic%20atmosphere%2C%20clean%20composition&width=600&height=350&seq=category-cover-02&orientation=landscape',
    articleCount: 48,
  },
  {
    id: '3',
    name: '动漫动画',
    slug: 'anime',
    description: '日漫国漫、动画电影、二次元文化深度解读',
    icon: 'ri-emotion-line',
    coverImage: 'https://readdy.ai/api/search-image?query=colorful%20anime%20style%20illustration%20with%20vibrant%20characters%2C%20Japanese%20animation%20aesthetic%2C%20dynamic%20composition%2C%20bright%20warm%20colors%2C%20clean%20background%2C%20playful%20atmosphere&width=600&height=350&seq=category-cover-03&orientation=landscape',
    articleCount: 42,
  },
  {
    id: '4',
    name: '综艺娱乐',
    slug: 'variety-show',
    description: '热门综艺盘点、节目测评、娱乐八卦速递',
    icon: 'ri-mic-2-line',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20colorful%20lights%20and%20modern%20stage%20design%2C%20variety%20show%20atmosphere%2C%20bright%20warm%20spotlights%2C%20entertainment%20production%2C%20clean%20composition&width=600&height=350&seq=category-cover-04&orientation=landscape',
    articleCount: 35,
  },
  {
    id: '5',
    name: '影评专栏',
    slug: 'film-review',
    description: '深度影评、电影分析、导演解读、观影指南',
    icon: 'ri-quill-pen-line',
    coverImage: 'https://readdy.ai/api/search-image?query=classic%20film%20projector%20with%20warm%20light%20beam%20in%20dark%20room%2C%20vintage%20cinema%20equipment%2C%20nostalgic%20atmosphere%2C%20golden%20dust%20particles%2C%20cinematic%20composition%2C%20clean%20background&width=600&height=350&seq=category-cover-05&orientation=landscape',
    articleCount: 29,
  },
  {
    id: '6',
    name: '行业观察',
    slug: 'industry-insight',
    description: '影视产业分析、流媒体趋势、市场数据解读',
    icon: 'ri-bar-chart-line',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20office%20workspace%20with%20data%20charts%20on%20screen%2C%20professional%20business%20setting%2C%20warm%20minimal%20lighting%2C%20clean%20corporate%20aesthetic%2C%20film%20industry%20analytics%20theme&width=600&height=350&seq=category-cover-06&orientation=landscape',
    articleCount: 22,
  },
];